import { ForboIconsData } from "../types/models";
import { buildIconsByEmailUrl } from "../utils/iconUrls";

export async function getIconsByEmail(email: string): Promise<ForboIconsData> {
  const response = await fetch(buildIconsByEmailUrl(email));

  if (!response.ok) {
    throw new Error("Failed to load icons");
  }

  return response.json();
}
